import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { SHOPCODE_REQUEST } from "../actions/types";
import {
  shopcodeOpenSuccess,
  shopcodeOpenFail,
  showErrorMessage,
  authSignOutSuccess,
} from "../actions";
import { authorizationHeader, getErrorMessage_v2 } from "../utils/apiUtil";
import axios from "axios";
import axiosRetry from "axios-retry";
axiosRetry(axios, {
  retries: 3,
  retryDelay: (retryCount) => {
    return retryCount * 1000;
  },
});

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

const shopcodeRequestApi = async (payload) => {
  const inputData = {
    coupon_id: payload.couponId,
    coupon_code: payload.code,
    shop_code: payload.shopCode,
  };
  return await axios
    .post(`${REACT_APP_API_URL}/v1/redemption/submit-shop-code`, inputData, {
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// WORKER

function* shopcodeRequest({ payload }) {
  try {
    const data = yield call(shopcodeRequestApi, payload);
    if (data.success === true) {
      yield put(shopcodeOpenSuccess());
    } else {
      yield put(shopcodeOpenFail());
    }
  } catch (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      localStorage.removeItem("member");
      yield put(authSignOutSuccess());
    } else {
      yield put(showErrorMessage(getErrorMessage_v2(error.response)));
    }
  }
}

// WATCHER

export function* shopcodeRequestFetchWatcher() {
  yield takeEvery(SHOPCODE_REQUEST, shopcodeRequest);
}

export default function* rootSaga() {
  yield all([fork(shopcodeRequestFetchWatcher)]);
}
